import { defineFcm } from '../shared/factory';

export const FCM_TOPIC_PAGE_CONTENT_GENERATION_ENABLED = defineFcm('topic_page_content_generation_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'petition-service',
		context: 'Topic pages',
		description: 'Kill switch for automated AI content generation on topic pages in petition_service.',
	});
